import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { finalize } from 'rxjs';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { ContactApiService } from '../../../../core/http/contact-api.service';
import { ContactSectionService } from './contact-section.service';

@Component({
  selector: 'app-contact-section',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule, RevealOnScrollDirective],
  templateUrl: './contact-section.component.html',
  styleUrl: './contact-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactSectionComponent {
  get content() {
    return this.contactService.content;
  }
  contactForm: FormGroup;
  contactSubmitted = false;
  isSubmitting = false;
  hasSubmitError = false;
  isSubmitSuccess = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly contactApiService: ContactApiService,
    private readonly contactService: ContactSectionService
  ) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9+()\-\s]{7,}$/)]],
      comment: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  submitContact(): void {
    this.contactSubmitted = true;
    this.hasSubmitError = false;
    this.isSubmitSuccess = false;

    if (this.contactForm.invalid || this.isSubmitting) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.contactForm.disable();
    this.contactApiService
      .sendMessage(this.contactForm.getRawValue())
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: () => {
          this.isSubmitSuccess = true;
          this.contactSubmitted = false;
          this.contactForm.reset();
          this.contactForm.enable();
        },
        error: () => {
          this.hasSubmitError = true;
          this.contactForm.enable();
        }
      });
  }
}
